export const FETCH_COOPERATION_HISTORY_REQUEST = "FETCH_COOPERATION_HISTORY_REQUEST";
